import type { CatalogPricingRuleModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'

import { RuleParamField } from './fields/RuleParamField'

/**
 * Renders the selected variant's params, one field per param (in author order).
 * Handles the no-variant, zero-param, and full-render states (spec §6).
 */
export const ParamsForm = ({
	variant,
	name,
	context,
}: {
	variant?: CatalogPricingRuleModel
	name: string
	context?: {
		optimizationGroupId?: string
	}
}) => {
	const { t } = useTranslation()
	if (!variant)
		return (
			<div
				data-testid='pr-tactic-empty'
				className='rounded-md border border-dashed p-6 text-center text-sm text-muted-foreground'
			>
				{t('pr_tactic_empty', {
					defaultValue: 'Select a pricing rule to configure its parameters.',
				})}
			</div>
		)

	return (
		<div data-testid='pr-tactic-params-form' className='space-y-3'>
			{variant.params.length === 0 ? (
				<div className='text-sm text-muted-foreground'>
					{t('pr_tactic_no_params', {
						defaultValue: 'This rule has no parameters.',
					})}
				</div>
			) : (
				<div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
					{variant.params.map((param) => (
						<RuleParamField
							key={param.id}
							param={param}
							name={`${name}.${param.id}`}
							context={context}
						/>
					))}
				</div>
			)}
		</div>
	)
}
